module.exports = __webpack_public_path__ + "static/media/exchange_return.86d1ec85.jpg";